import { QueryConfig } from "store/utils/query-config";

export const waMarketingCampaignsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-createdAt"],
  },
};
